import { IDamageManagementInitialValues } from '../../types';

export const INITIAL_VALUES: IDamageManagementInitialValues = {
  key: undefined,
  organization: 0,
  policy_number: undefined,
  upload_files: [],
  email_users: [],
  damage_type: '',
  branch: '',
  country: '',
  city: '',
  location_code: '',
  damage_date: '',
  pending_loss: undefined,
  currency: '',
  expert: '',
  reporter: '',
  recent_status: '',
  description: '',
};
